/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable react/require-default-props */
/* eslint-disable import/extensions */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/button-has-type */
/* eslint-disable camelcase */
import React, { useContext, useMemo, useEffect } from 'react'
import { Image } from '@telus/koodo-ui-kit'
import { useLocation } from 'react-router'
import { useSelector } from 'react-redux'
import { setPageAnalytics } from '@apps/utils/Analytics'
import { ANALYTICS_EVENT_TYPES } from '@apps/utils/constants'
import {
  APPLICATION_STATE,
  ApplicationContext
} from '@apps/contexts/ApplicationContext'
import PropTypes from 'prop-types'
import { getById, getBySlug, getByTitle } from '@apps/utils/contentful'
import BodyBold from '@/apps/components/Typography/BodyBold'
import Heading3 from '@/apps/components/Typography/Heading3'
import useTagManagerInfo from '../../../_engine/hooks/useTagManagerInfo'

const Modal = ({
  isOpen = false,
  closeModal,
  title = null,
  children,
  showControls = true,
  showBackLink = false,
  backLinkText = 'Go Back',
  disableClose = false
}) => {
  if (!isOpen) {
    return null
  }

  const { pageContent } = useSelector((state) => state.common.content)
  const { 
    [APPLICATION_STATE.CURRENT_LANGUAGE]: language, 
    [APPLICATION_STATE.CURRENT_REGION]: region 
    } = useContext(ApplicationContext)
  
  const haveSimPage = getById(pageContent, `haveSimPage`)?.[language] || {}
  const { shortTextFields, images } = haveSimPage

  const location = useLocation()

  const content = useMemo(() => {
    if (!images && !shortTextFields) return {}
    return {
      closeIcon: getByTitle(images, 'close-icon')?.url,
      backLinkText: getBySlug(shortTextFields, 'backlink-text')?.value
    }
  }, [shortTextFields, images])

  const tagManagerInfo = useTagManagerInfo()

  const pushClickAnalytics = ({ click_text, event_type, event_click = ANALYTICS_EVENT_TYPES.CLICK }={}) => {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push(
      setPageAnalytics(location, 'click', region, language, {
        ...tagManagerInfo,
        click_text
      }, event_type, event_click)
    )
  }

  useEffect(() => {
    if (!showControls && !disableClose) {
      const timer = setTimeout(() => {
        closeModal()
      }, 5000)
      return () => clearTimeout(timer)
    }
  }, [isOpen, closeModal, showControls])

  const handleClose = () => {
    if (disableClose) return
    if (closeModal) {
      pushClickAnalytics({click_text:content?.backLinkText ?? backLinkText,event_type: 'Back link text'})
      closeModal()
    }
  }
  return (
    <div
      role="dialog"
      className="fixed inset-0 bg-gray-600/75 z-60 flex justify-center items-center"
      onClick={handleClose}
    >
      <div className="relative">
        <div
          className={`bg-white rounded-lg max-w-2xl w-full p-8 ${!showControls ?? `min-h-128`}`}
          onClick={(e) => e.stopPropagation()}
        >
          <div className={`flex justify-between ${showControls ?? 'mb-4'}`}>
            <Heading3 className="text-primary text-pop-up leading-8">{title}</Heading3>

            {showControls && (
              <button type="button" onClick={closeModal} className="absolute top-4 right-4" data-testid="close-modal">
                <Image alt="close" src={content?.closeIcon} />
              </button>
            )}
          </div>

          <div>{children}</div>

          {showBackLink && (
            <div className="flex flex-col items-center my-2 md:my-4">
              <button onClick={closeModal} className="text-center" data-testid="go-back">
                <BodyBold className="underline" textColor="text-primary">
                  {content?.backLinkText ?? backLinkText}
                </BodyBold>
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

Modal.propTypes = {
  closeModal: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
  isOpen: PropTypes.bool,
  title: PropTypes.string,
  showControls: PropTypes.bool,
  disableClose: PropTypes.bool,
  showBackLink: PropTypes.bool,
  backLinkText: PropTypes.string
}

export default Modal
